module.exports = __webpack_public_path__ + "static/img/related_articles.9a4ba86d.png";